<template>
  <!--[pageHeader]-->
  <header class="pageHeader">
    <div class="pageHeader-headline">
      <h2 class="headline headline-lg pageHeader-headline-text">{{ pageName }}</h2>
    </div>
    <div class="pageHeader-button" v-if="isSettingShown">
      <button type="button" class="btn btn-sm btn-bd-main" @click="handleClick">表示設定</button>
    </div>
    <nav class="scrollX pageHeader-nav">
      <ul class="pageHeader-nav-set">
        <li class="pageHeader-nav-item" v-for="pageNav in pageNavs" :key="pageNav.id">
          <router-link
            v-if="checkPolicy(pageNav.routeName) && (pageNav.eventFlag ? isOfficeHadEvent : true)"
            class="pageHeader-nav-link"
            :to="{ name: pageNav.routeName }"
            :class="{ 'is-active': pageNav.includes ? navPointName.includes(pageNav.routeName) : navPointName === pageNav.routeName }"
            >{{ pageNav.name }}</router-link
          >
        </li>
      </ul>
    </nav>
  </header>
  <!--[/pageHeader]-->
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { RoleConstants } from '@/constants/role';

defineProps({
  pageName: String,
  pageNavs: Array,
  handleClick: {
    type: Function,
    required: false,
  },
  isSettingShown: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const route = useRoute();

const infor = computed(() => store.getters['auth/infor']);
const isOfficeHadEvent = computed(() => store.getters['auth/isOfficeHadEvent']);
const isClientChild = computed(() => store.getters['auth/isClientChild']);
const navPointName = computed(() => route.name);

const checkPolicy = (routeName) => {
  if (infor.value.kind === RoleConstants.ROLE_OFFICE) {
    if (
      (!infor.value.role.includes(RoleConstants.ROLE_EVENTS_OFFICE) && routeName === 'SettingEvent') ||
      (isClientChild.value && routeName === 'EventSummaryCompany')
    ) {
      return false;
    }
  }
  return true;
};
</script>
